import React from 'react';
import { FormInput, FormGroup, FormFeedback } from 'shards-react';
import { useTranslation } from 'react-i18next';
import './style.css';
const Input = (props) => {
  const { inputHasErrors, label } = props;
  const { t, i18n } = useTranslation();

  return (
    <FormGroup>
      {label && <label className="capitalize-first-letter">{label}</label>}
      <FormInput invalid={inputHasErrors} {...props} />
      <FormFeedback invalid>{t(inputHasErrors)}</FormFeedback>
    </FormGroup>
  );
};

export default Input;
